/**
 * Return the site config from light-modules/opella-lm-templates/templates/global/prototype/areas/head/head.ftl
 * Empty object is created to allow editor suggestions
 */
const config = {
  editMode: false,
  context: "/",
  site: "",
  userid: "",
  currentLocale: ""
};
const configID = "site-config";

try {
  let configObj = {};
  if(document.getElementById(configID)) {
    configObj = JSON.parse(document.getElementById(configID).textContent);
  }

  Object.assign(config, configObj);
}
catch (e) {
  console.log(e);
}

export default config;
